import { Component, Type } from '@angular/core';
import { IGetClass, IModalWindow, ISetOptions } from 'src/app/utils/interfaces/modal-dialog.interface';
import { ModalWindowsTypes, TabNames } from 'src/app/core/enums';
import { ExamsListOverviewComponent } from './exams-list-overview/exams-list-overview.component';

@Component({
    selector: 'asg-overview-exams',
    templateUrl: './overview-exams.component.html',
    styleUrls: ['./overview-exams.component.scss'],
    standalone: true,
    imports: [ExamsListOverviewComponent]
})
export class OverviewExamsComponent implements IModalWindow, ISetOptions, IGetClass {
  messageKey: TabNames;

  getWindowType(): Type<IModalWindow> {
    return OverviewExamsComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.PENDING_EXAMS_WINDOW;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | ISetOptions | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      default: return null;
    }
  }

  setOptions(options: any): void {
    options = options || {};
    this.messageKey = options.messageKey;
  }

  getClass(): string {
    return 'pending-exams-modal';
  }
}
